"use client"

import { ApplicationEnvironmentMolecule } from "@/app/env/store"
import { useMolecule } from "bunshi/react"
import { useMemo } from "react"
import type { GachaApiOptions } from "./gacha-api"

export function useGachaApiOptions(): GachaApiOptions {
  const { bffBaseUrl, collectorCryptGachaBaseUrl } = useMolecule(
    ApplicationEnvironmentMolecule,
  )

  return useMemo(
    () => ({ bffBaseUrl, collectorCryptGachaBaseUrl }),
    [bffBaseUrl, collectorCryptGachaBaseUrl],
  )
}
